import { ApiForm } from '../../components';

import './getQuote.scss';

const GetQuote = () => {
  return (
    <section className="get-quote">
      <div className="container">
        <h2 className="section-title">
          Get Your
          <br />
          Quote
          <br /> Online!
        </h2>

        <div className="form-wrapper">
          <ApiForm />
        </div>
      </div>
    </section>
  );
};

export default GetQuote;
